var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4A154B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.333 6a2 2 0 000 4h2V8a2.001 2.001 0 00-2-2zm0 5.334H8a2 2 0 000 4h5.333a2 2 0 100-4zM26 13.333a2 2 0 00-4 0v2h2a2 2 0 002-2zm-5.333 0V8a2 2 0 10-4 0v5.333a2 2 0 104 0zM18.667 26a2 2 0 000-4h-2v2c0 1.103.894 1.998 2 2zm0-5.335h5.334a2 2 0 100-4h-5.333a2 2 0 00-.001 4zM6 18.666a2 2 0 104 0v-2H8a2 2 0 00-2 2zm5.334 0V24a2 2 0 004 .001v-5.333a2 2 0 10-4 0z",
    fill: "#fff"
  })));
}

export default SvgSlack;